import { render } from "./webHeaderDesktop.vue?vue&type=template&id=3c1363a9&scoped=true&ts=true"
import script from "./webHeaderDesktop.vue?vue&type=script&lang=ts"
export * from "./webHeaderDesktop.vue?vue&type=script&lang=ts"

import "./webHeaderDesktop.vue?vue&type=style&index=0&id=3c1363a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1363a9"]])

export default __exports__